'use client'
import { socket } from '../Containers/MainContainer';
import { canUsePagination, numberWithCommas } from '../utils';

import { useEffect } from 'react';
import { useState } from 'react';
import { Pagination } from 'react-bootstrap';
import Skeleton, { SkeletonTheme } from 'react-loading-skeleton';
import PlutoMenu from './PlutoMenu';
import PaginationPluto from './Pagination';
import VerifyAdmin from './PlutoVerify';
import { Link } from 'react-router-dom';

function PlutoOffersToday() {
    const [userProfile, setUserProfile] = useState({})
    const [earnings, setEarnings] = useState([0, 0, 0, 0, 0]);
    const [page, setPage] = useState(1)
    const [pageNumber, setPageNumber] = useState(-1)
    const [userId, setUserId] = useState(0);
    const [canUse, setCanUse] = useState(true);
    const [username, setUsername] = useState('')
    const [rank, setRank] = useState(0)
    const [type, setType] = useState(0)

    useEffect(() => {
        socket.on('response_get_admin_offers_today', (data) => {
            setEarnings(data.withdrawals)
            setPageNumber(Math.ceil(data.withdrawalsLength / 5))
            setUserProfile(data)
            canUsePagination(true)
            setRank(data.rank)

        })
        socket.emit('getOffersAdminToday', {
            offers_like: username,
            type,
            page,
        })
    }, [])
    useEffect(() => {
        socket.on('reTakePendingData', () => {
            socket.emit('getOffersAdminToday', {
                offers_like: username,
                type,

                page,
            })
        })
    }, [])

    const getCbRateStyle = (rate) => {
        const numRate = parseInt(rate);
        if (numRate <= 10 && numRate >= 1) return { background: 'rgba(210,153,34,0.15)', color: '#d29922' };
        if (numRate <= 20 && numRate > 10) return { background: 'rgba(210,153,34,0.25)', color: '#d29922' };
        if (numRate <= 40 && numRate > 20) return { background: 'rgba(248,81,73,0.15)', color: '#f85149' };
        if (numRate >= 50) return { background: 'rgba(248,81,73,0.25)', color: '#f85149' };
        return {};
    };

    return (
        <SkeletonTheme baseColor="#161b22" highlightColor="#21262d">

            <div className="modal-body" style={{ color: '#e6edf3', background: '#0d1117', minHeight: '100vh', padding: '24px' }}>
                {/* Stats Card */}
                <div style={{ marginBottom: '24px' }}>
                    {userProfile.withdrawalsLength != undefined ?
                        <div style={{
                            background: '#161b22',
                            border: '1px solid #21262d',
                            borderLeft: '3px solid #58a6ff',
                            borderRadius: '12px',
                            padding: '20px',
                            display: 'inline-block',
                            minWidth: '160px'
                        }}>
                            <p style={{
                                fontSize: '24px',
                                fontWeight: 700,
                                color: '#e6edf3',
                                margin: 0,
                                marginBottom: '4px'
                            }}>
                                {numberWithCommas(userProfile.withdrawalsLength)}
                            </p>
                            <p style={{
                                color: '#8b949e',
                                fontSize: '11px',
                                fontWeight: 500,
                                textTransform: 'uppercase',
                                letterSpacing: '0.8px',
                                margin: 0
                            }}>Count offers</p>
                        </div>
                        : <Skeleton style={{ width: '136px', height: '50px' }} />}
                </div>

                {/* Main Table Card */}
                <div style={{
                    background: '#161b22',
                    border: '1px solid #21262d',
                    borderRadius: '12px',
                    overflow: 'hidden',
                    marginBottom: '20px'
                }}>
                    {/* Card Header */}
                    <div style={{
                        padding: '16px 20px',
                        borderBottom: '1px solid #21262d',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'space-between'
                    }}>
                        <p style={{ color: '#e6edf3', fontWeight: 600, fontSize: '16px', margin: 0 }}>Suspect Offers</p>
                        <input
                            style={{
                                borderRadius: '8px',
                                background: '#0d1117',
                                border: '1px solid #30363d',
                                color: '#e6edf3',
                                fontSize: '13px',
                                padding: '8px 14px',
                                outline: 'none',
                                width: '260px',
                                transition: 'border-color 0.2s'
                            }}
                            onFocus={(e) => e.target.style.borderColor = '#58a6ff'}
                            onBlur={(e) => e.target.style.borderColor = '#30363d'}
                            onChange={(e) => {
                                setUsername(e.currentTarget.value)
                                setEarnings([0, 0, 0, 0, 0, 0, 0, 0, 0, 0])
                                socket.emit('getOffersAdminToday', {
                                    offers_like: e.currentTarget.value.toLowerCase(),
                                    type,
                                    page: 1,
                                })
                            }}
                            type="text"
                            name="amount"
                            placeholder="Search by offer name"
                            autoComplete="off"
                        />
                    </div>

                    {/* Table */}
                    <div style={{ overflowX: 'auto' }}>
                        <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                            <thead>
                                <tr style={{ background: '#161b22' }}>
                                    <th style={{ minWidth: '250px', textAlign: 'left', padding: '12px 16px', fontSize: '11px', fontWeight: 500, color: '#8b949e', textTransform: 'uppercase', letterSpacing: '0.8px', borderBottom: '1px solid #21262d' }}>Name</th>
                                    <th style={{ minWidth: '200px', padding: '12px 16px', fontSize: '11px', fontWeight: 500, color: '#8b949e', textTransform: 'uppercase', letterSpacing: '0.8px', borderBottom: '1px solid #21262d', textAlign: 'left' }}>Amount</th>
                                    <th style={{ minWidth: '90px', padding: '12px 16px', fontSize: '11px', fontWeight: 500, color: '#8b949e', textTransform: 'uppercase', letterSpacing: '0.8px', borderBottom: '1px solid #21262d', textAlign: 'left' }}>Payout</th>
                                    <th style={{ minWidth: '100px', padding: '12px 16px', fontSize: '11px', fontWeight: 500, color: '#8b949e', textTransform: 'uppercase', letterSpacing: '0.8px', borderBottom: '1px solid #21262d', textAlign: 'left' }}>Wall Name</th>
                                    <th style={{ minWidth: '100px', padding: '12px 16px', fontSize: '11px', fontWeight: 500, color: '#8b949e', textTransform: 'uppercase', letterSpacing: '0.8px', borderBottom: '1px solid #21262d', textAlign: 'left' }}>Date</th>
                                    <th style={{ minWidth: '80px', padding: '12px 16px', fontSize: '11px', fontWeight: 500, color: '#8b949e', textTransform: 'uppercase', letterSpacing: '0.8px', borderBottom: '1px solid #21262d', textAlign: 'left' }}>Country</th>
                                    <th style={{ minWidth: '100px', padding: '12px 16px', fontSize: '11px', fontWeight: 500, color: '#8b949e', textTransform: 'uppercase', letterSpacing: '0.8px', borderBottom: '1px solid #21262d', textAlign: 'left' }}>Category</th>
                                    <th style={{ minWidth: '80px', padding: '12px 16px', fontSize: '11px', fontWeight: 500, color: '#8b949e', textTransform: 'uppercase', letterSpacing: '0.8px', borderBottom: '1px solid #21262d', textAlign: 'left' }}>CB Rate</th>
                                    <th style={{ minWidth: '100px', maxWidth: '100px', padding: '12px 16px', fontSize: '11px', fontWeight: 500, color: '#8b949e', textTransform: 'uppercase', letterSpacing: '0.8px', borderBottom: '1px solid #21262d', textAlign: 'left' }}>Edit</th>
                                </tr>
                            </thead>
                            <tbody>
                                {earnings.map((earning, i) => {
                                    return (
                                        <tr
                                            key={earning.id || i}
                                            style={{
                                                borderBottom: '1px solid #21262d',
                                                transition: 'background 0.2s'
                                            }}
                                            onMouseEnter={(e) => e.currentTarget.style.background = '#1c2128'}
                                            onMouseLeave={(e) => e.currentTarget.style.background = 'transparent'}
                                        >
                                            <td style={{ minWidth: '250px', textAlign: 'left', color: '#e6edf3', padding: '14px 16px', fontSize: '13px' }}>{earning.name || <Skeleton style={{ width: '30px' }} />}</td>
                                            <td style={{ minWidth: '200px', color: '#3fb950', fontWeight: 500, padding: '14px 16px', fontSize: '13px' }}>{earning.amount || <Skeleton style={{ width: '30px' }} />}</td>
                                            <td style={{ minWidth: '90px', color: '#58a6ff', fontWeight: 500, padding: '14px 16px', fontSize: '13px' }}>{earning.payout || <Skeleton style={{ width: '30px' }} />}</td>
                                            <td style={{ minWidth: '100px', color: '#c9d1d9', padding: '14px 16px', fontSize: '13px' }}>{earning.wall || <Skeleton style={{ width: '30px' }} />}</td>
                                            <td style={{ minWidth: '100px', color: '#8b949e', padding: '14px 16px', fontSize: '13px' }}>{earning.date || <Skeleton style={{ width: '30px' }} />}</td>
                                            <td style={{ minWidth: '80px', color: '#c9d1d9', padding: '14px 16px', fontSize: '13px' }}>{earning.country || <Skeleton style={{ width: '30px' }} />}</td>
                                            <td style={{ minWidth: '100px', color: '#c9d1d9', padding: '14px 16px', fontSize: '13px' }}>{earning.category || <Skeleton style={{ width: '30px' }} />}</td>
                                            <td style={{ minWidth: '80px', padding: '14px 16px', fontSize: '13px' }}>
                                                {earning.cb_rate ? (
                                                    <span style={{
                                                        padding: '4px 8px',
                                                        borderRadius: '9999px',
                                                        fontSize: '12px',
                                                        fontWeight: 500,
                                                        ...getCbRateStyle(earning.cb_rate)
                                                    }}>
                                                        {earning.cb_rate}
                                                    </span>
                                                ) : <Skeleton style={{ width: '30px' }} />}
                                            </td>

                                            <td style={{ padding: '14px 16px' }}>
                                                <Link to={`/pluto/user/${earning.user_id}`} style={{
                                                    display: 'inline-flex',
                                                    alignItems: 'center',
                                                    justifyContent: 'center',
                                                    padding: '6px 12px',
                                                    background: '#21262d',
                                                    border: '1px solid #30363d',
                                                    borderRadius: '8px',
                                                    color: '#e6edf3',
                                                    fontSize: '12px',
                                                    fontWeight: 500,
                                                    textDecoration: 'none',
                                                    transition: 'background 0.2s',
                                                    minWidth: '80px',
                                                    maxWidth: '100px'
                                                }}
                                                    onMouseEnter={(e) => e.target.style.background = '#30363d'}
                                                    onMouseLeave={(e) => e.target.style.background = '#21262d'}
                                                >
                                                    {earning.id == undefined ? <Skeleton style={{ width: '30px' }} /> : 'Check User'}
                                                </Link>
                                            </td>
                                        </tr>
                                    )
                                })}
                            </tbody>
                        </table>
                    </div>
                </div>

                {/* Pagination */}
                <div style={{ marginBottom: '16px' }}>
                    {pageNumber == -1 ? <Skeleton style={{ width: '100%' }} /> : <PaginationPluto pageNumber={pageNumber} requestNewList={(page) => {
                        canUsePagination(false)
                        setEarnings([0, 0, 0, 0, 0])
                        socket.emit('getOffersAdminToday', {
                            offers_like: username,
                            type,
                            page,
                        })
                    }} />}
                </div>

                {/* Jump to Page */}
                <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginTop: '12px' }}>
                    <input onKeyDown={
                        (e) => {
                            if (e.key == 'Enter') {
                                canUsePagination(false)
                                setEarnings([0, 0, 0, 0, 0])
                                socket.emit('getOffersAdminToday', {
                                    offers_like: username,
                                    type,
                                    page: document.getElementById('jumptotoday3').value,
                                })
                            }
                        }
                    } type="number" id="jumptotoday3" style={{
                        background: '#0d1117',
                        border: '1px solid #30363d',
                        borderRadius: '8px',
                        color: '#e6edf3',
                        padding: '8px 12px',
                        fontSize: '13px',
                        outline: 'none',
                        width: '80px'
                    }}
                        onFocus={(e) => e.target.style.borderColor = '#58a6ff'}
                        onBlur={(e) => e.target.style.borderColor = '#30363d'}
                    />
                    <button onClick={() => {
                        canUsePagination(false)
                        setEarnings([0, 0, 0, 0, 0])
                        socket.emit('getOffersAdminToday', {
                            offers_like: username,
                            type,
                            page: document.getElementById('jumptotoday3').value,
                        })
                    }
                    } style={{
                        color: '#ffffff',
                        background: '#238636',
                        border: '1px solid #2ea043',
                        borderRadius: '8px',
                        padding: '8px 16px',
                        fontSize: '13px',
                        fontWeight: 500,
                        cursor: 'pointer',
                        transition: 'background 0.2s'
                    }}
                        onMouseEnter={(e) => e.target.style.background = '#2ea043'}
                        onMouseLeave={(e) => e.target.style.background = '#238636'}
                    >Go to page</button>
                </div>
            </div>
        </SkeletonTheme>
    )
}

export default PlutoOffersToday
